"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateInput = void 0;
const validator_1 = __importDefault(require("validator"));
function validateInput(field, value) {
    if (!value) {
        if (field.toLowerCase().includes('password')) {
            return 'Please enter a valid password';
        }
        switch (field) {
            case 'accountName':
                return 'Please enter an account name';
            case 'storeName':
                return 'Please enter a store name';
            case 'subdomain':
                return 'Please enter a valid subdomain';
            case 'name':
                return 'Please enter a valid name';
            case 'email':
                return 'Please enter a valid email';
            default:
                return 'Please enter a valid input';
        }
    }
    if (field === 'email') {
        if (!validator_1.default.isEmail(value)) {
            return 'Please enter a valid email';
        }
    }
    return false;
}
exports.validateInput = validateInput;
